// extracted by mini-css-extract-plugin
module.exports = {"recommendations":"Feeds_recommendations__ANQpK","recommendationsExperiment":"Feeds_recommendationsExperiment__eDDOt"};